export default {
  PUSH_OITS: 'PUSH_OITS',
  PUSH_OIT_TRAINING_PHASES: 'PUSH_OIT_TRAINING_PHASES',
  PUSH_OIT_TASK_RESPONSES: 'PUSH_OIT_TASK_RESPONSES',
  REPLACE_OIT: 'REPLACE_OIT',
  REPLACE_OIT_TRAINING_PHASE: 'REPLACE_OIT_TRAINING_PHASE',
  RESET_OITS_STATE: 'RESET_OITS_STATE',
  SET_OIT_IS_ASSIGNING_FTO_FOR: 'SET_OIT_IS_ASSIGNING_FTO_FOR',
  SET_OITS_IS_LOADING: 'SET_OITS_IS_LOADING',
  SET_SELECTED_OIT_GUID: 'SET_SELECTED_OIT_GUID',
  UPDATE_TRAINING_TRACKER: 'UPDATE_TRAINING_TRACKER',
  UPDATE_PHASE_TRAINING_TRACKER: 'UPDATE_PHASE_TRAINING_TRACKER',
  UPDATE_PHASE_PROJECTED_DATES: 'UPDATE_PHASE_PROJECTED_DATES',
  UPDATE_TRAINING_PHASE_HAS_RISK_ALERTS: 'UPDATE_TRAINING_PHASE_HAS_RISK_ALERTS',
  REOPEN_PHASE: 'REOPEN_PHASE',
  UPDATE_PHASE_START_DATE: 'UPDATE_PHASE_START_DATE',
};
